import { Injectable } from '@angular/core';
import { MenuNaviService } from 'src/app/utils/menu-navi.service';
import { TraductionService } from 'src/app/utils/traduction.service';
import { WebsocketService } from 'src/app/utils/websocket.service';
import { UserService } from '../User/user.service';
import { Ask } from '../Ask/ask.service';
import { Chat } from '../Chat/chat.service';
import { ToolsService } from '../../utils/tools.service';
import { Camera, CameraPermissionState, CameraPermissionType, CameraResultType, GalleryPhoto, Photo } from '@capacitor/camera';
import { Geolocation, Position } from '@capacitor/geolocation';

import { DocumentsService } from '../../utils/documents.service';
import { StatusBar, Style, Animation } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { SqliService } from 'src/app/utils/sqli.service';
import { Diagnostic } from '@awesome-cordova-plugins/diagnostic/ngx';
import { ScanQr } from '../ScanQr/scan-qr';
import { Field } from '../Field/field';
import { DateTimeField } from '../DateTimeField/date-time-field';
import { GeolocationField } from '../GeolocationField/geolocation-field';
import { DocumentsField } from '../DocumentsField/documents-field';
import { FormGroup } from '@angular/forms';
import { SelectorField } from '../SelectorField/selector-field';
import { Documents } from '../Documents/documents';
import { PhoneNumberField } from '../PhoneNumberField/phone-number-field';
import { UserContact } from '../Contact/user-contact';
import { ModalController, ModalOptions } from '@ionic/angular';
import { OfflineService } from './offline.service';
import { States } from '../../enums/States';
import { FieldsTempaltesConditions } from '../FieldsTemplatesCondition/fields-tempaltes-conditions';
import { Notification } from '../Notification/notification';
import { Cgu } from '../Cgu/cgu';
import OneSignal from 'onesignal-cordova-plugin';
import { AuthToken } from '../AuthToken/auth-token';
import { Share } from '../Share/share';
import { UpdaterService } from '../Updater/updater.service';
import { LoggerService } from '../../utils/logger.service';
import { CameraViewerService } from 'src/app/Modales/CameraViewer/camera-viewer.service';

@Injectable()
export class ModulesManagerService {
  private Modules = {}
  private fakeAsk: Ask;
  private currentModal: HTMLIonModalElement = null;
  private FileMimeType = {
    'audio/x-mpeg': 'mpega',
    'application/postscript': 'ps',
    'audio/x-aiff': 'aiff',
    'application/x-aim': 'aim',
    'image/x-jg': 'art',
    'video/x-ms-asf': 'asx',
    'audio/basic': 'ulw',
    'video/x-msvideo': 'avi',
    'video/x-rad-screenplay': 'avx',
    'application/x-bcpio': 'bcpio',
    'application/octet-stream': 'exe',
    'image/bmp': 'dib',
    'text/html': 'html',
    'application/x-cdf': 'cdf',
    'application/pkix-cert': 'cer',
    'application/java': 'class',
    'application/x-cpio': 'cpio',
    'application/x-csh': 'csh',
    'text/css': 'css',
    'application/msword': 'doc',
    'application/xml-dtd': 'dtd',
    'video/x-dv': 'dv',
    'application/x-dvi': 'dvi',
    'application/vnd.ms-fontobject': 'eot',
    'text/x-setext': 'etx',
    'image/gif': 'gif',
    'application/x-gtar': 'gtar',
    'application/x-gzip': 'gz',
    'application/x-hdf': 'hdf',
    'application/mac-binhex40': 'hqx',
    'text/x-component': 'htc',
    'image/ief': 'ief',
    'text/vnd.sun.j2me.app-descriptor': 'jad',
    'application/java-archive': 'jar',
    'text/x-java-source': 'java',
    'application/x-java-jnlp-file': 'jnlp',
    'image/jpeg': 'jpg',
    'application/javascript': 'js',
    'text/plain': 'txt',
    'application/json': 'json',
    'audio/midi': 'midi',
    'application/x-latex': 'latex',
    'audio/x-mpegurl': 'm3u',
    'image/x-macpaint': 'pnt',
    'text/troff': 'tr',
    'application/mathml+xml': 'mathml',
    'application/x-mif': 'mif',
    'video/quicktime': 'qt',
    'video/x-sgi-movie': 'movie',
    'audio/mpeg': 'mpa',
    'video/mp4': 'mp4',
    'video/mpeg': 'mpg',
    'video/mpeg2': 'mpv2',
    'application/x-wais-source': 'src',
    'application/x-netcdf': 'nc',
    'application/oda': 'oda',
    'application/vnd.oasis.opendocument.database': 'odb',
    'application/vnd.oasis.opendocument.chart': 'odc',
    'application/vnd.oasis.opendocument.formula': 'odf',
    'application/vnd.oasis.opendocument.graphics': 'odg',
    'application/vnd.oasis.opendocument.image': 'odi',
    'application/vnd.oasis.opendocument.text-master': 'odm',
    'application/vnd.oasis.opendocument.presentation': 'odp',
    'application/vnd.oasis.opendocument.spreadsheet': 'ods',
    'application/vnd.oasis.opendocument.text': 'odt',
    'application/vnd.oasis.opendocument.graphics-template': 'otg',
    'application/vnd.oasis.opendocument.text-web': 'oth',
    'application/vnd.oasis.opendocument.presentation-template': 'otp',
    'application/vnd.oasis.opendocument.spreadsheet-template': 'ots',
    'application/vnd.oasis.opendocument.text-template': 'ott',
    'application/ogg': 'ogx',
    'video/ogg': 'ogv',
    'audio/ogg': 'spx',
    'application/x-font-opentype': 'otf',
    'audio/flac': 'flac',
    'application/annodex': 'anx',
    'audio/annodex': 'axa',
    'video/annodex': 'axv',
    'application/xspf+xml': 'xspf',
    'image/x-portable-bitmap': 'pbm',
    'image/pict': 'pict',
    'application/pdf': 'pdf',
    'image/x-portable-graymap': 'pgm',
    'audio/x-scpls': 'pls',
    'image/png': 'png',
    'image/x-portable-anymap': 'pnm',
    'image/x-portable-pixmap': 'ppm',
    'application/vnd.ms-powerpoint': 'pps',
    'image/vnd.adobe.photoshop': 'psd',
    'image/x-quicktime': 'qtif',
    'image/x-cmu-raster': 'ras',
    'application/rdf+xml': 'rdf',
    'image/x-rgb': 'rgb',
    'application/vnd.rn-realmedia': 'rm',
    'application/rtf': 'rtf',
    'text/richtext': 'rtx',
    'application/font-sfnt': 'sfnt',
    'application/x-sh': 'sh',
    'application/x-shar': 'shar',
    'application/x-stuffit': 'sit',
    'application/x-sv4cpio': 'sv4cpio',
    'application/x-sv4crc': 'sv4crc',
    'image/svg+xml': 'svgz',
    'application/x-shockwave-flash': 'swf',
    'application/x-tar': 'tar',
    'application/x-tcl': 'tcl',
    'application/x-tex': 'tex',
    'application/x-texinfo': 'texinfo',
    'image/tiff': 'tiff',
    'text/tab-separated-values': 'tsv',
    'application/x-font-ttf': 'ttf',
    'application/x-ustar': 'ustar',
    'application/voicexml+xml': 'vxml',
    'image/x-xbitmap': 'xbm',
    'application/xhtml+xml': 'xhtml',
    'application/vnd.ms-excel': 'xls',
    'application/xml': 'xsl',
    'image/x-xpixmap': 'xpm',
    'application/xslt+xml': 'xslt',
    'application/vnd.mozilla.xul+xml': 'xul',
    'image/x-xwindowdump': 'xwd',
    'application/vnd.visio': 'vsd',
    'audio/x-wav': 'wav',
    'image/vnd.wap.wbmp': 'wbmp',
    'text/vnd.wap.wml': 'wml',
    'application/vnd.wap.wmlc': 'wmlc',
    'text/vnd.wap.wmlsc': 'wmls',
    'application/vnd.wap.wmlscriptc': 'wmlscriptc',
    'video/x-ms-wmv': 'wmv',
    'application/font-woff': 'woff',
    'application/font-woff2': 'woff2',
    'model/vrml': 'wrl',
    'application/wspolicy+xml': 'wspolicy',
    'application/x-compress': 'z',
    'application/zip': 'zip'
  };

  private onUpdateModuleData: Array<any> = []
  constructor(private browserCamera: CameraViewerService, private updater: UpdaterService, private offlineManager: OfflineService, private ws: WebsocketService, private usr: UserService, private navi: MenuNaviService, private trad: TraductionService, private tool: ToolsService, private sqli: SqliService, private diagnostic: Diagnostic, private documents: DocumentsService, private modalCtrl: ModalController) {

    this.tool.ScanQr.Manager = this
    this.updater.initiate(this)
    this.sqli.initiate(this)
    this.offlineManager.initiate(this)
    this.navi.initiate(this)
    this.trad.Manager = this
    this.documents.initiate(this)
    this.ws.initiate(this)
    this.usr.initiate(this)
    this.ws.AddModuleUpdateEvent((eventData) => { this.UpdateModuleData(eventData) })
    this.ws.AddModuleDeleteEvent((eventData) => { this.deleteModuleData(eventData.Module, eventData.Id) })
    this.ws.AddEvent("InternalKeys", "WrongKeys", (data) => {
      if (this.ws.isConnected)
        for (const internalKey of data.Data.InternalKeys)
          this.removeInternalKey(internalKey)
    })
    this.launcheOneSignal()
  }

  /**
   * 
   * @param cb // here pass function(string, number) => void  string = Module, number = Id
   * @param 
   * @param string 
   * @param number 
   */
  public OnUpdateModuleData(cb: (Module: string, Id: number) => void) {
    this.onUpdateModuleData.push(cb)
  }

  private FireUpdate(Module: string, Id: number) {
    for (const cb of this.onUpdateModuleData)
      cb(Module, Id)
  }

  public async displayModal(Options: ModalOptions) {
    this.closeModal()
    this.currentModal = await this.modalCtrl.create(Options)
    await this.currentModal.present()
  }

  public async closeModal() {
    if (this.currentModal != null) {
      await this.currentModal?.dismiss()
      this.currentModal = null
    }
  }

  public logOutOneSignal() {
    if (!window["cordova"]) return LoggerService.log("OneSignal not available on browser");
    try {

      OneSignal.logout()
    } catch (e) {
      LoggerService.log(e)
    }
  }

  public logIntoOneSignal(email: string) {
    if (!window["cordova"]) return LoggerService.log("OneSignal not available on browser");
    try {
      OneSignal.logout()
      OneSignal.login(email)
      //OneSignal.User.addEmail(email)

    } catch (e) {
      LoggerService.log(e)
    }

  }

  private async launcheOneSignal() {
    await this.tool.DeviceReady()
    if (!window["cordova"]) return LoggerService.log("OneSignal not available on browser");
    try {
      OneSignal.initialize("15d3c561-08d1-4cef-aa67-3fcddb616435")
      OneSignal.Notifications.addEventListener('click', async (e) => {
        let clickData = await e.notification;
        let extraData = clickData.additionalData
        if (extraData) {
          if (extraData["Chat"]) {
            this.navi.navigateTo('/chat', { id: extraData["Chat"] })
          } else if (extraData["Ask"]) {
            this.navi.navigateTo('/ask', { id: extraData["Ask"] })

          }
        }
        LoggerService.log("Notification Clicked : " + JSON.stringify(clickData));
      })
      if (!OneSignal.Notifications.hasPermission()) {
        if (OneSignal.Notifications.canRequestPermission()) {
          OneSignal.Notifications.requestPermission(true)

        }
      }

    } catch (e) {
      LoggerService.log(e)
    }
  }


  public async DismissTopModal() {
    await (await this.modalCtrl.getTop())?.dismiss()
  }

  private async UpdateModuleData(eventData: any) {
    this.DefineModule(eventData.Module)
    if (this.Modules[eventData.Module][eventData.Id] == null) {
      this.Modules[eventData.Module][eventData.Id] = await this.GenerateClass(eventData.Module, eventData.Data, false);
    } else {
      await this.Modules[eventData.Module][eventData.Id].Hydrate(eventData.Data, false)
    }

    //force les mise à jour annexes et récupération de champs sur ask
    /*switch(eventData.Module){
      case "Fields":
        if(eventData.Data?.AskId>0 && !this.Modules["Asks"][eventData.Data.AskId]){
          ((await this.GetModuleData("Asks", eventData.Data.AskId)) as Ask)?.ForceUpdate( )
        }
        break
    }*/
  }

  printModule() {
    LoggerService.log("Modules data:", this.Modules)
  }

  get Updater(): UpdaterService {
    return this.updater
  }

  get Documents(): DocumentsService {
    return this.documents
  }

  get Sqli(): SqliService {
    return this.sqli
  }

  get ScanQr(): ScanQr {
    return this.tool.ScanQr
  }

  get Tool(): ToolsService {
    return this.tool
  }

  get Usr(): UserService {
    return this.usr
  }

  get Navi(): MenuNaviService {
    return this.navi
  }

  get Trad(): TraductionService {
    return this.trad
  }

  get Ws(): WebsocketService {
    return this.ws
  }

  get OfflineService(): OfflineService {
    return this.offlineManager
  }


  getElementsBy(target: string | 'Id' | 'ClassName' | 'Name' | 'TagName' | 'TagNameNS', value: string): any {
    let event = "getElementsBy" + target
    if (target == "Id") {
      let ele = document.getElementById(value)
      if (ele != null) return [ele]
      return []
    }
    if (typeof document[event] == "undefined") return LoggerService.warn(event + " is not exist in document object");
    return document[event](value)

  }

  private hidden = false;
  async hideStatusBar() {
    if (!Capacitor.isPluginAvailable('StatusBar')) return;

    await this.tool.sleep(300);
    await StatusBar.setOverlaysWebView({ overlay: false });
    await StatusBar.show({
      animation: Animation.None,
    });
    await StatusBar.setBackgroundColor({ color: '#202125' });
    await StatusBar.setStyle({ style: Style.Light });
    /*await StatusBar.hide();
    this.hidden = true
    this.keepHidden()*/
  };

  private hidelooping = false;
  private async keepHidden() {
    if (this.hidelooping) return;
    this.hidelooping = true
    while (this.hidden) {
      await this.tool.sleep(250)
      let status = await StatusBar.getInfo()
      if (status.visible) {
        await StatusBar.hide();
      }
    }
    this.hidelooping = false
  }

  private async waitForLoopEnded() {
    while (this.hidelooping) await this.tool.sleep(500)
  }

  async showStatusBar() {
    if (!Capacitor.isPluginAvailable('StatusBar')) return;
    await this.waitForLoopEnded()
    StatusBar.setOverlaysWebView({ overlay: false });
    await StatusBar.show();
  };

  async hasGeolocationPermission() {
    if (Capacitor.isPluginAvailable('Diagnostic')) {
      if (!(await this.diagnostic.isGpsLocationEnabled())) {
        this.tool.notify(this.trad.Parse("STR_NO_GPS"));
        return false; // Indicate that GPS location is not enabled
      }
    }

    let perm = await Geolocation.checkPermissions();

    if (!this.Tool.isPlatform("web") && (perm.coarseLocation.includes("prompt") || perm.location.includes("prompt"))) {
      await Geolocation.requestPermissions({
        permissions: ['coarseLocation', 'location']
      });
      perm = await Geolocation.checkPermissions();
    }
    return perm;
  }

  async getGeolocation(parsed: boolean = true): Promise<any> {
    let Perms = await this.hasGeolocationPermission();
    let defaultPostion = {
      lat: 48.85466063,
      lng: 2.29316423
    }; // Error occurred, user notified
    if (!Perms) {
      return defaultPostion; // GPS location not enabled, user notified
    }

    if (!this.Tool.isPlatform("web")) {
      if (Perms.coarseLocation !== "granted" || Perms.location !== "granted") {
        this.tool.notify(this.trad.Parse("STR_NO_PERMISSION"));
        return defaultPostion
      }
    }

    let timeout = 2500;
    try {
      let options: PositionOptions = {
        maximumAge: 0,
        timeout: timeout,
        enableHighAccuracy: Perms.coarseLocation === "granted" && Perms.location === "granted"
      };

      let posi: Position = await Geolocation.getCurrentPosition(options);
      if (parsed) {
        return {
          lat: posi?.coords.latitude?.toFixed(8) || defaultPostion.lat,
          lng: posi?.coords.longitude?.toFixed(8) || defaultPostion.lng
        };
      } else {
        return posi;
      }
    } catch (error) {
      LoggerService.error("Geolocation error:", error)
      this.Tool.notify(this.Trad.Parse("STR_NO_PERMISSION"));
      return defaultPostion
    }
  }

  async hasCameraPermission() {
    let granted: CameraPermissionState = "granted"
    let denied: CameraPermissionState = "denied"
    let perm = await Camera.checkPermissions().catch((e) => { LoggerService.log("Camera permission check error:", e); return null })
    if (perm == null) {
      return this.tool.isPlatform("web")
    }
    let isWeb = this.tool.isPlatform("web")
    if (!isWeb && (perm.camera != granted || perm.camera != granted)) {
      let perms = []
      if (perm.camera !== denied && perm.camera.toString().includes("prompt"))
        perms.push("camera")
      if (perm.photos != granted)
        perms.push("photos")
      if (perms.length)
        await Camera.requestPermissions({
          permissions: perms as Array<CameraPermissionType>
        })
    }

    perm = await Camera.checkPermissions()
    return isWeb ?
      perm.camera != denied && perm.photos != denied // web browser
      :
      perm.camera == granted && perm.photos == granted; // smartphone
  }


  private getExtentionFromType(mimeType: string) {
    return this.FileMimeType[mimeType.toLocaleLowerCase()]
  }

  async takePicture(): Promise<File> {
    if (!this.Tool.isPlatform('web')) {
      if (!await this.hasCameraPermission()) {
        this.tool.notify(this.trad.Parse('STR_NO_PERMISSION'));
        return null;
      }
      const photo = await Camera.getPhoto({
        quality: 100, saveToGallery: false, allowEditing: true,
        correctOrientation: true, presentationStyle: 'fullscreen',
        resultType: CameraResultType.Uri,
        promptLabelCancel: this.trad.Parse('STR_CANCEL'),
        promptLabelPhoto: this.trad.Parse('STR_USE_CAMERA'),
        promptLabelPicture: this.trad.Parse('STR_DOCUMENT_PICKER'),
        promptLabelHeader: this.trad.Parse('STR_METHODE_CHOICE'),

      });
      let file: File = await (await fetch(photo.webPath))?.blob() as File;
      if (!file.name) {
        file = new File([file], photo.webPath.split('/').pop() + '.' + this.getExtentionFromType(file.type), { type: file.type });
      }
      return file;
    }

    // Browser path
    const res = await this.browserCamera.takePicture({
      facingMode: 'environment',
      maxWidth: 1920,
      quality: 0.9
    });

    if (res.cancelled) return null;                 // l’utilisateur a annulé → pas de toast d’erreur
    if (!res.file) {
      // vraie erreur (ex: toBlob, device down, etc.)
      this.tool.notify(this.trad.Parse('STR_ERROR'));
      return null;
    }
    return res.file;
  }

  async takeGaleryPicture(): Promise<Array<GalleryPhoto>> {
    if (!await this.hasCameraPermission()) {
      this.tool.notify(this.trad.Parse("STR_NO_PERMISSION"));
      return null
    }
    return await (await Camera.pickImages({})).photos
  }

  newId(Module: string): number {
    if (this.Modules[Module] == null) return -1;
    let id = parseInt(Object.keys(this.Modules[Module]).sort((a, b) => parseInt(a) - parseInt(b)).shift() || "0")

    if (id >= 0) return -1;
    return --id;
  }

  get NotifiedAsk() {
    let asksIds = []
    let asksNoti = this.GetListModuleData("Notifications").filter(data => {
      if (data.Parent == "Ask" && data.Quantity > 0) {
        asksIds.push(data.AskId)
        return true
      }
      return false

    }).length
    return asksNoti + this.GetListModuleData("Notifications").filter(data => {
      if (!asksIds.includes(data.AskId) && data.Parent == "Chat" && data.Quantity > 0) {
        return true
      }
      return false

    }).length
  }

  purge() {
    for (const [Name, Module] of Object.entries(this.Modules)) {
      for (const [Id, Data] of Object.entries(Module)) {
        delete this.Modules[Name][Id]
      }
      delete this.Modules[Name]
    }
    this.Modules = []
  }

  public async waitFormIsReadyToRead(form: FormGroup) {
    // form.markAsUntouched()
    form.markAllAsTouched()
    // form.markAsUntouched()
    await this.Tool.sleep(100)
    while (form.pending) {
      await this.Tool.sleep(100)
    }
  }

  public addInternalKey(internalKey: string) {
    if (this.usr.isLoged) return;
    let internalKeys: Array<string> = this.Tool.jsonParse(window.localStorage.internalKeys, [])
    internalKeys.push(internalKey)
    window.localStorage.internalKeys = JSON.stringify(internalKeys)
  }


  public removeInternalKey(internalKey: string) {
    let internalKeys: Array<string> = this.Tool.jsonParse(window.localStorage.internalKeys, [])
    if (!internalKeys.includes(internalKey)) return;
    internalKeys.splice(internalKeys.indexOf(internalKey), 1)
    window.localStorage.internalKeys = JSON.stringify(internalKeys)
  }

  public hasInternalKey(internalKey) {
    return this.InternalKeys.includes(internalKey)
  }

  public get InternalKeys(): Array<string> {
    if (this.usr.isLoged) return [];
    return this.Tool.jsonParse(window.localStorage.internalKeys, []) as Array<string>
  }

  private async GenerateClass(Module: string, ToHydrate: any = null, newOne: boolean = false): Promise<any> {
    if (ToHydrate == null && newOne) {
      ToHydrate = {}
      ToHydrate.Id = this.newId(Module);
    }
    let Data: any = null;
    switch (Module) {
      case "Documents":
        Data = new Documents(this, ToHydrate)
        break
      case "UsersContacts":
        Data = new UserContact(this, ToHydrate)
        break
      case "Asks":
        Data = new Ask(this, false)
        break
      case "Cgus":
        Data = new Cgu(this, ToHydrate)
        break
      case "AuthTokens":
        Data = new AuthToken(this, ToHydrate)
        break
      case "Chats":
        Data = new Chat(this, ToHydrate);
        break
      case "Notifications":
        Data = new Notification(this, ToHydrate);
        break
      case "Shares":
        Data = new Share(this, ToHydrate);
        break
      case "FieldsTemplatesConditions":
        Data = new FieldsTempaltesConditions(this, ToHydrate);
        break
      case "Fields":
        if (typeof ToHydrate.Type == "undefined") {
          Data = new Field(this, ToHydrate)
          break
        }
        let isMobile = !this.Tool.isPlatform("web")
        ToHydrate.isMobile = isMobile
        switch (ToHydrate.Type) {
          case "textarea":
          case "boolean":
          case "input":
            Data = new Field(this, ToHydrate)
            break
          case "phonenumber":
            Data = new PhoneNumberField(this, ToHydrate)
            break
          case "datetime":
            Data = new DateTimeField(this, ToHydrate)
            break
          case "selector":
            Data = new SelectorField(this, ToHydrate)
            break
          case "geolocation":
            Data = new GeolocationField(this, ToHydrate)
            break
          case "document":
            Data = new DocumentsField(this, ToHydrate)
            break
          default:
            LoggerService.warn("type de champ non géré", ToHydrate.Type)
            break
        }
        break;
      default:
        LoggerService.warn("ModuleManagerService: GenerateClass: Module not found: " + Module);
    }
    if (ToHydrate.Id != 0 && Data != null)
      Data.Hydrate({ id: ToHydrate.Id }, ToHydrate.Id > 0)
    this.FireUpdate(Module, Data.Id)
    return Data
  }

  public getFakeAsk(newOne: boolean = false) {
    if (!newOne && this.fakeAsk == null) this.fakeAsk = new Ask(this, true)
    if (newOne) this.fakeAsk = new Ask(this, true)
    return this.fakeAsk
  }

  public deleteModuleData(Module, Id = 0) {
    if (Id === 0) delete this.Modules[Module]
    this.DefineModule(Module)
    if (Id && this.Modules[Module][Id]) delete this.Modules[Module][Id]
  }

  private DefineModule(Module: string) {
    if (this.Modules[Module] == null) this.Modules[Module] = {};
  }

  /**
   * cette fonction ne fait pas d'appel au serveur mais sert à attendre de recevoir une donnée précise que le serveur est entrain de créer/envoyer
   * @param maxWaitTimeInSeconds 
   * @param Module 
   * @param Id 
   * @returns
   */
  public async WaitForModuleData(maxWaitTimeInSeconds: number, Module: string, Id: number): Promise<boolean> {
    let timeInMs = maxWaitTimeInSeconds * 1000;
    this.DefineModule(Module)
    while (timeInMs > 0) {
      if (this.Modules[Module][Id] != null) return true;
      await this.Tool.sleep(250);
      timeInMs -= 250
    }
    false
  }

  public async GetModuleData(Module: string, Id: number, Parent: string = "", ParentId: number = 0) {
    this.DefineModule(Module)
    if (Id != 0) {
      if (this.Modules[Module][Id] == null) {
        await this.LoadModule(Module, Id, Parent, ParentId).catch(LoggerService.error);
      }
      return this.Modules[Module][Id];
    } else {
      if (!this.GetListModuleData(Module, Parent, ParentId).length) {
        await this.LoadList(Module, Parent, ParentId).catch(LoggerService.error);
      }
      return this.GetListModuleData(Module, Parent, ParentId);
    }
  }

  public GetStateByName(name: string = ""): States {
    for (const state of Object.values(States)) {
      if (Number.isInteger(state)) continue;
      if (this.trad.Parse("STR_" + (state as string).toUpperCase()).toLocaleLowerCase().trim().includes(name.toLocaleLowerCase().trim())) return state as States
    }
    return null
  }

  public GetStateNameByStates(lookingFor: States): string {
    for (const state of Object.keys(States)) {
      if (Number.isInteger(state)) continue;
      if (lookingFor == ((state as any) as States)) return ("STR_" + States[state]).toUpperCase()
    }
    return "null"
  }

  public GetListModuleData(Module: string, Parent: string = "", ParentId: number = 0, filter: any = null): Array<any> {
    this.DefineModule(Module)
    try {
      if (Parent != "" && ParentId != 0)
        return (Object.values(this.Modules[Module])).filter((data: any, id) => {
          if (!(Module != "Documents" ? data[Parent + "Id"] === ParentId : (data?.isParentOf(Parent, ParentId) == true))) return false
          if (filter != null) {
            for (const [propertie, value] of Object.entries(filter))
              if (data[propertie] != value) return false
          }
          return true
        })
    } catch (error) {
      LoggerService.warn("GetListModuleData error:", error)
      return []
    }
    return Object.values(this.Modules[Module]).filter((data: any, id) => {
      if (filter != null) {
        for (const [propertie, value] of Object.entries(filter))
          if (data[propertie] != value) return false
      }
      return true
    })
  }

  public async LoadList(Module: string, Parent: string = "", ParentId: number = 0) {
    this.DefineModule(Module)
    await this.LoadModule(Module, 0, Parent, ParentId).catch(LoggerService.error);
  }


  private async LoadModule(Module: string, Id: number, Parent: string = "", ParentId: number = 0) {

    this.DefineModule(Module)
    if (Id < 0) {
      if (this.Modules[Module][Id] == null)
        this.Modules[Module][Id] = await this.GenerateClass(Module, null, true)
      return this.Modules[Module][Id]
    }
    if (this.Modules[Module][Id] == null) {
      let answer = (await this.ws.Send(Module, "select", { Id: Id, Parent: Parent, ParentId: ParentId }, true).catch(e => { LoggerService.error("LoadModule error:", e); return null })) as any;
      if (answer.error != null && answer.error != "")
        return;
      let Promises = [];
      let Datas: Array<[string, any]> = Object.entries(answer.Data)
      if (Datas.length)
        for (const [key, Data] of Datas) {
          this.DefineModule(answer.Module)
          if (this.Modules[answer.Module][Data.Id] == null)
            this.Modules[answer.Module][Data.Id] = await this.GenerateClass(answer.Module, Data);

          //on hydrate l'instance
          /*!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! 

          Si on ne repsect pas le schéma ca marchera jamais 
          respecter le constructeur et l'hydrate pour chaque class module
          
          si on change les arguments du constructeur ou de l'hydrate
          
          !!!!! on doit changer les arguments du constructeur ou de l'hydrate de chaque class module !!!!

          !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!*/
          Promises.push(this.Modules[answer.Module][Data.Id].Hydrate(Data, true));
        }
      await Promise.all(Promises).catch(LoggerService.error);
    }
    return Id == 0 ? (this.GetListModuleData(Module, Parent, ParentId)) : this.Modules[Module][Id];

  }

}
